
export function mergeVehicles(normalizedVehicles) {
  let vehiclesByVin = {};
  let assocKeys = {};

  function addNormalizedVehicles(key, vehicles) {
    if (vehicles !== null && vehicles.length > 0) {
      assocKeys[key] = vehicles;
      for (let v of vehicles) {
        let vehicle = vehiclesByVin[v.vin] ?? { vin: v.vin, assoc: { 'cvi': [] } };
        if (!vehicle.assoc[key]) {
          vehicle.assoc[key] = [];
        }
        vehicle.assoc[key].push(v);
        vehiclesByVin[v.vin] = vehicle;
      }
    }
  }

  function getCombinedVehicles() {

    function getProp(vehicle, propName) {
      // Fallback order for the merged summary row, so this *does* fall through to a 2.1 value
      // where 1.0 has none -- 1.0 stays preferred where both exist. What keeps the two systems
      // distinguishable is not this list: each key keeps its own `assoc` bucket, column and tab,
      // and the compare view renders every source in its own column. AD-7 accepts the fallback
      // here because the summary list shows only identity/description fields, never pricing.
      const propPriorityKeys = ["cvi", "cvi2", "va", "mvs", "vasrc", "ddc", "vinsol", "atc"];
      for (let key of propPriorityKeys) {
        if (vehicle.assoc[key] && vehicle.assoc[key].length > 0 && vehicle.assoc[key][0][propName]) {
          return vehicle.assoc[key][0][propName];
        }
      }
      return null;
    }

    function normalizeValue(v) {
      if (v === "NONE" || v === "UNSPECIFIED" || v === null || v === undefined)
        return "";

      return v;
    }

    function getStatus(vehicle) {
      let statuses = [];

      const keys = ["cvi", "va"];
      for (let key of keys) {
        if (vehicle.assoc[key] && vehicle.assoc[key].length > 0) {
          statuses.push(vehicle.assoc[key][0].purchaseStatus);
        }
      }

      let status = statuses[0];
      for (let i in statuses) {
        if (normalizeValue(statuses[i]) !== normalizeValue(status)) {
          return "MISMATCH";
        }
      }
      return status;
    }

    function getVehicleErrors(vehicle) {
      let errors = [];
      for (let key of Object.keys(assocKeys)) {
        if (!vehicle.assoc[key])
          errors.push(`Vehicle not in ${key}`);
      }

      for (let key of Object.keys(vehicle.assoc)) {
        if (vehicle.assoc[key].length > 1)
          errors.push(`Multiple ${key} vehicles`);
      }

      return errors.length > 0 ? errors : null;
    }

    // Flatten list of vin vehicles
    let vehicles = { all: [], filtered: {}, cviNotVa: [], vaNotCvi: [], vinNotDdc: [], vinNotCvi: [], multiMatch: [] };
    for (let vin in vehiclesByVin) {
      let v = vehiclesByVin[vin];
      vehicles.all.push(v);
    }

    // Extract common properties
    vehicles.all.forEach((v) => {
      v.entityId = getProp(v, "entityId");
      v.year = getProp(v, "year");
      v.make = getProp(v, "make");
      v.model = getProp(v, "model");
      v.trim = getProp(v, "trim");
      v.stock = getProp(v, "stock");
      v.type = getProp(v, "type");
      v.exteriorColor = getProp(v, "exteriorColor");
      v.dateInStock = getProp(v, "dateInStock");
      v.listPrice = getProp(v, "listPrice");
      v.invoicePrice = getProp(v, "invoicePrice");
      v.disposition = getProp(v, "disposition");
      v.mediaUrl = getProp(v, "mediaUrl");
      v.status = getStatus(v);
      v.error = getVehicleErrors(v);
    });

    // Sort by date in stock
    vehicles.all.sort((a, b) => (a.dateInStock < b.dateInStock) ? 1 : -1);

    // Build categorized lists
    for (let key of Object.keys(assocKeys)) {
      vehicles.filtered[key] = [];
    }

    vehicles.all.forEach((v) => {
      for (let key of Object.keys(assocKeys)) {
        if (v.assoc[key] && v.assoc[key].length > 0) {
          vehicles.filtered[key].push(v);
          if (key === "cvi" && (!v.assoc["va"] || v.assoc["va"].length === 0)) {
            vehicles.cviNotVa.push(v);
          }
          if (key === "va" && (!v.assoc["cvi"] || v.assoc["cvi"].length === 0)) {
            vehicles.vaNotCvi.push(v);
          }
          if (key === "vinsol" && (!v.assoc["ddc"] || v.assoc["ddc"].length === 0)) {
            vehicles.vinNotDdc.push(v);
          }
          if (key === "vinsol" && (!v.assoc["cvi"] || v.assoc["cvi"].length === 0)) {
            vehicles.vinNotCvi.push(v);
          }
        } else {
        }
        if (v.assoc[key] && v.assoc[key].length > 1) {
          vehicles.multiMatch.push(v);
        }
      }
    });

    return vehicles;
  }

  for (let nv of normalizedVehicles) {
    addNormalizedVehicles(nv.key, nv.vehicles);
  }

  return getCombinedVehicles();
}
